// extracted by mini-css-extract-plugin
export default {"root":"style_root__3+M2F","icon":"style_icon__jBThV","text":"style_text__4DULN"};